const Styles = {
  container: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh'
  },
  innerContainer: {
    display: 'flex',
    flex: 1,
    paddingBottom: 64,
    paddingTop: 84,
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: 15,
    paddingRight: 15
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/feeds/News/styles.js